import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Modal from "react-modal"
import { Form } from "react-final-form"
import styled from "styled-components"
import { StyledForm, Gap, CenterSection } from "Styles"
import { theme } from "Theme"
import Config from "Data"
import { FormHiddenFields, FormDebug, LoadingSpinner, Utils, Link } from "Components"
import { Recaptcha, Input, StyledSelect, Spacer } from "Components/FormElements"
const { fontSize } = theme

function ValidateEmail(email) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  if (email.match(validRegex)) {
    return true
  } else {
    return false
  }
}

const emailblockReg =
  /^([\w]+@(?!gmail.com)(?!yahoo.com)(?!ymail.com)(?!hotmail.com)(?!msn.com)(?!aol.com)(?!live.com)(?!icloud.com)(?!me.com)([\w-]+\.)+[\w-]{2,4})?$/

const Wrapper = styled.section`
  border-radius: ${theme.borderRadius.ui};
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 4rem 2rem;
    flex-direction: column;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto;
  }
  max-width: ${theme.layout.base};
`

const Content = styled.div`
  display: block;
  margin: 0 auto;
  text-align: left;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Container = styled.div`
  position: relative;
  padding: 1rem 1rem 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem 2rem 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const PrivacyLink = styled((props) => <Link {...props} />)`
  font-size: ${fontSize.smallish};
  padding: 1rem;
`

const windowGlobal = typeof window !== "undefined" && window

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      loading: false,
      recaptcha: false,
    }
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
  }

  verifyCallback(recaptchaToken) {
    this.setState({ ...this.state, recaptcha: true })
    // console.log("verifyCallback!")
  }

  onLoadRecaptcha() {
    // console.log("onLoadRecaptcha!")
    if (this.captchaObject) {
      this.captchaObject.reset()
      // console.log("onLoadRecaptcha After Reset!")
      this.captchaObject.execute()
    }
  }

  render() {
    const { props } = this
    const {
      postSubscribe,
      node,
      image,
      brand,
      title,
      subtitle,
      isOpen,
      closeModal,
      onAfterOpen,
      onRequestClose,
      onChangeInput,
    } = props

    let formData = {
      formName: "FormPostSubscribe",
      state: this.state,
      origin: windowGlobal ? windowGlobal.location.href : "",
      retURL: "",
      country: windowGlobal.country,
      id: this.props.id,
      email: this.props.email,
      brand: Config.brand,
      mailingList: "post_subscribe_cxosync",
    }

    const toggleLoading = (e) => {
      this.setState({ ...this.state, loading: false })
    }

    const resetRecaptcha = (e) => {
      this.setState({ ...this.state, recaptcha: false })
    }

    function postData(url = ``, data = {}) {
      return fetch(url, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrer: "no-referrer",
        body: JSON.stringify(data),
      })
        .then((response) => {
          response
            .json()
            .then((data) => {
              resetRecaptcha()
              if (data.retURL) {
                windowGlobal.location = data.retURL
              } else {
                toggleLoading()
                onRequestClose()
              }
            })
            .catch(function (e) {
              console.error("handled the error")
              console.error(e)
            })
        })
        .catch((error) => console.error("Error:", error))
    }

    const onSubmit = async (values) => {
      console.log(JSON.stringify(values, 0, 2))
      this.setState({ loading: true })
      postData(Utils.endpoints.referee, values).catch((error) => console.error(error))
    }

    const handleChange = (e) => {
      formData[e.target.name] = e.target.value
      this.setState(formData)
    }

    return (
      <>
        <StaticQuery
          query={graphql`
            query {
              events: allGoogleSheetOverview2020(
                filter: { calendar: { eq: true } }
                sort: { order: DESC, fields: date }
              ) {
                totalCount
                edges {
                  node {
                    id
                    brand
                    region
                    events
                    eventTitle
                    stateCity
                    date
                    eventSite
                    twitter
                    image
                  }
                }
              }
              banners: bannersJson {
                banner {
                  attend {
                    childImageSharp {
                      gatsbyImageData(width: 1440, placeholder: BLURRED)
                    }
                  }
                }
              }
            }
          `}
          render={(data) => {
            const { loading } = this.state
            return (
              <Modal
                id="modalPostSubscribe"
                contentLabel="modalPostSubscribe"
                closeTimeoutMS={400}
                isOpen={isOpen}
                onAfterOpen={onAfterOpen}
                onRequestClose={onRequestClose}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}>
                {!loading && (
                  <>
                    <button className="btn-close" onClick={closeModal}>
                      X
                    </button>
                  </>
                )}

                <Container>
                  {loading && <LoadingSpinner />}
                  {!postSubscribe && (
                    <Wrapper>
                      <Content>
                        <CenterSection.Title>Thank You.</CenterSection.Title>

                        <CenterSection.Subtitle>
                          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vero officiis magni laudantium. Eos
                          expedita velit amet quisquam obcaecati ducimus quia maiores repellat voluptas molestiae,
                          nostrum recusandae consequatur, aut consequuntur tempora?
                        </CenterSection.Subtitle>
                      </Content>
                    </Wrapper>
                  )}
                  {postSubscribe && (
                    <>
                      <Gap></Gap>
                      <Form
                        initialValues={formData}
                        onSubmit={onSubmit}
                        validate={(values) => {
                          const errors = {}
                          if (!values.firstName) {
                            errors.firstName = "Required"
                          }
                          if (!values.lastName) {
                            errors.lastName = "Required"
                          }
                          if (!this.state.recaptcha) {
                            errors.recaptcha = "Required"
                          }
                          return errors
                        }}
                        render={({ form, handleSubmit, reset, submitting, pristine, values }) => (
                          <>
                            <StyledForm className="form">
                              <FormHiddenFields hiddenData={formData} />

                              <StyledSelect
                                label="Interested in:"
                                name="interestedIn"
                                placeholder="Please select one"
                                value={[]}
                                options={[
                                  { label: "Atteding an Event", value: "Attending" },
                                  { label: "Sponsoring an Event", value: "Sponsoring" },
                                ]}
                                className="fullWidthElement"
                              />

                              <StyledSelect
                                label="Region:"
                                name="region"
                                placeholder="Please select one"
                                value={[]}
                                options={[
                                  { label: "ALL", value: "all" },
                                  { label: "North America West", value: "NA West" },
                                  { label: "North America East", value: "NA East" },
                                  { label: "North America Central", value: "NA Central" },
                                  { label: "Euorpe", value: "Euorpe" },
                                  { label: "Asia", value: "Asia" },
                                ]}
                                className="fullWidthElement"
                              />

                              <Input
                                name="firstName"
                                label="First Name"
                                placeholder="First Name"
                                type="text"
                                className="firsthalfWidthElement"
                                // required={true}
                              />
                              <Input
                                name="lastName"
                                label="Last Name"
                                placeholder="Last Name"
                                type="text"
                                className="lasthalfWidthElement"
                                // required={true}
                              />

                              <div className="fullWidthElement">
                                <Recaptcha
                                  name="Recaptcha"
                                  onloadCallback={this.onloadCallback}
                                  verifyCallback={this.verifyCallback}
                                />
                              </div>

                              <Spacer />

                              <div className="buttonsWrapper">
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={form.reset}
                                  data-gtm={`Form Post Subscribe | Reset`}
                                  disabled={submitting || pristine}>
                                  Clear
                                </button>
                                <button
                                  type="submit"
                                  className="btn"
                                  // disabled={submitting || pristine}
                                  onClick={handleSubmit}
                                  data-gtm={`Form Post Subscribe | Submit`}>
                                  Submit
                                </button>
                              </div>
                              <div className="footerWrapper">
                                <PrivacyLink to={"/privacy/"} title={`Privacy policy`}>
                                  Privacy policy
                                </PrivacyLink>
                              </div>
                            </StyledForm>

                            <FormDebug data={values}></FormDebug>
                          </>
                        )}
                      />
                    </>
                  )}
                </Container>
              </Modal>
            )
          }}
        />
      </>
    )
  }
}
